/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	$(function () {
	    // Only run on mobile
	    function isMobile() {
	        return $('body').hasClass('cc-mobile');
	    }

	    // Hide all tooltips except the specified one
	    function hideOtherTooltips($currentTooltip) {
	        $('.cc-component-textbox-tooltip.cc-hero-info-point').not($currentTooltip).removeClass('show');
	    }

	    // For each hero info tooltip 
	    $('.cc-component-textbox-tooltip.cc-hero-info-point').each(function (index) {
	        var $tooltip = $(this);
	        var hoverTimeout = void 0;

	        // Function to adjust tooltip position for bottom-left variant
	        function adjustBottomLeftTooltip() {
	            var $tooltipContent = $tooltip.find('.cc-component-textbox-tooltip-content');
	            var $textbox = $tooltip.closest('.cc-component-textbox');
	            var $subtitle = $textbox.find('.cc-component-textbox-subtitle');
	            var windowWidth = window.innerWidth;

	            // Only apply to bottom-left variant on tablet breakpoint (768px-1024px)
	            if ($textbox.hasClass('bottom-left') && windowWidth >= 768 && windowWidth <= 1024) {
	                var subtitleWidth = $subtitle.width();

	                // Remove all classes first
	                $tooltipContent.removeClass('narrow-subtitle wide-subtitle');

	                // If subtitle width is less than 174px, add narrow class
	                if (subtitleWidth < 174) {
	                    $tooltipContent.addClass('narrow-subtitle');
	                }
	                // If subtitle width is greater than 684px, add wide class
	                else if (subtitleWidth > 580) {
	                        $tooltipContent.addClass('wide-subtitle');
	                    }
	            }
	        }

	        // Desktop hover behavior
	        if (!isMobile()) {
	            $tooltip.on('mouseenter', function () {
	                clearTimeout(hoverTimeout);
	                hideOtherTooltips($tooltip);
	                $tooltip.addClass('show');

	                // Adjust position after showing tooltip
	                adjustBottomLeftTooltip();
	            });

	            // Hide tooltip on mouseleave with delay to allow moving to tooltip content
	            $tooltip.on('mouseleave', function () {
	                hoverTimeout = setTimeout(function () {
	                    $tooltip.removeClass('show');
	                }, 100);
	            });

	            $tooltip.find('.cc-component-textbox-tooltip-content').on('mouseenter', function () {
	                clearTimeout(hoverTimeout);
	            });

	            $tooltip.find('.cc-component-textbox-tooltip-content').on('mouseleave', function () {
	                hoverTimeout = setTimeout(function () {
	                    $tooltip.removeClass('show');
	                }, 100);
	            });
	        }

	        // Toggle tooltip on icon click (mobile only)
	        $tooltip.on('click', function (e) {
	            if (isMobile()) {
	                hideOtherTooltips($tooltip);
	                $tooltip.toggleClass('show');

	                // Adjust position after showing tooltip
	                if ($tooltip.hasClass('show')) {
	                    adjustBottomLeftTooltip();
	                }
	            }
	        });

	        // Hide tooltip when clicking outside
	        $(document).on('click.tooltip' + index, function (e) {
	            if (isMobile() && !$tooltip.is(e.target) && $tooltip.has(e.target).length === 0) {
	                $tooltip.removeClass('show');
	            }
	        });
	    });
	});

/***/ })
/******/ ]);